import OurGallery from './OurGallery';

export default OurGallery;
